/* eslint-disable react/require-default-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import HoverableSlideOutModal from '../../../components/HoverableSlideOutModal';
import Bag from '../../../components/Bag';
import { analyze } from '../../../../../helpers';
import BagIcon from '../../../components/Bag/subcomponents/BagIcon';

function BagModal({ bagCount, bagIconProps, onMouseEnter, onMouseLeave, bagPeek, ...otherProps }) {
  const [bagModalOpen, setBagModalOpen] = useState(0);

  function handleBagEnter() {
    setBagModalOpen(parseInt(bagModalOpen, 10) + 1);
    return onMouseEnter && onMouseEnter();
  }

  function handleBagLeave() {
    setBagModalOpen(0);
    return onMouseLeave && onMouseLeave();
  }

  useEffect(() => {
    if (bagModalOpen > 0) {
      const timer = setTimeout(() => {
        analyze({
          name: 'ViewedBagPeek',
          bagCount,
          data: {},
        });
      }, 1000);
      return () => clearTimeout(timer);
    }
    return setBagModalOpen(bagModalOpen);
  }, [bagModalOpen]);

  if (bagCount > 0 && bagPeek) {
    return (
      <HoverableSlideOutModal
        onMouseEnter={handleBagEnter}
        onMouseLeave={handleBagLeave}
        showModal
        hideOverlay={false}
        {...otherProps}
        target={<BagIcon {...bagIconProps} />}
        component={<Bag />}
      />
    );
  }

  return (
    <HoverableSlideOutModal
      showModal={false}
      hideOverlay
      {...otherProps}
      target={<BagIcon {...bagIconProps} />}
    />
  );
}


BagModal.propTypes = {
  bagIconProps: PropTypes.shape({}),
  bagCount: PropTypes.string
};

export default BagModal;
